import tokens from '@kluein/design-tokens';
import { Box, Button } from '@kluein/klue-ui';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { UserAvatar } from 'components/common/user-avatar';
import { useAuth } from 'contexts/auth';
import { APP_V1_BASEURL } from 'lib/urls';
import store from 'store';
import TEST_IDS from 'test-ids';

import type { UserType } from 'api/api.types';
import type { RootState } from 'store/store.types';

const StyledBox = styled(Box)`
  transition: transform 250ms 125ms ease-in-out;

  &:hover {
    transform: scale(1.1);
  }
`;

const NavBarAvatar = ({
  borderColor = tokens.color.primary.contrastlight,
}: {
  borderColor?: string;
}) => {
  const { isCurator } = useAuth();
  const user = useSelector<RootState, UserType | null>(
    (state) => state.auth.user,
  );
  const notifications = useSelector<RootState, number>(
    store.select.auth.notifications,
  );

  const { t } = useTranslation(['Common']);

  const href = isCurator
    ? `${APP_V1_BASEURL}/notifications`
    : `${APP_V1_BASEURL}/users/${user?.id}`;

  return (
    <StyledBox alignSelf="center">
      <Button
        variant="plain"
        key="appNavBar.navBarLink.usersButton"
        title={`${t('Common:actions.edit')} ${t('Common:app.profile')}`}
        href={href}
        data-test-id={TEST_IDS.layout.appNavBar.userAvatarLink}
        badge={
          isCurator && !!notifications
            ? {
                value: notifications,
                max: 99,
              }
            : undefined
        }
      >
        <UserAvatar
          userId={user?.id as number}
          size={22}
          radius="xl"
          style={{ border: `${tokens.borderWidth.small} solid ${borderColor}` }}
        />
      </Button>
    </StyledBox>
  );
};

export default memo(NavBarAvatar);
